import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

const useMyNonOperator = (page: string, div: string) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [noneList, setNoneList] = useState<MyOperatorItemDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();
  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.mypage.op3, [location.search, page]],
    () =>
      fetcher.mypage.postNonOperatorList1({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        place: String(searchParams.place) || '',
        group: String(page),  
      }),
    {
      enabled: (page === 'op3' && (div === '999' || div ==='101')), 
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setNoneList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { noneList, searchResult, refetch };
};

export default useMyNonOperator;
